import goTo from "vuetify/es5/services/goto";

// Scroll page to first class appearing, in most cases should be called inside $nextTick
export function scrollToClass(cssClass) {
  const firstElement = document.getElementsByClassName(cssClass).item(0);
  if (firstElement) {
    firstElement.scrollIntoView();
  }
}

export function scrollToId(cssId) {
  const element = document.getElementById(cssId);
  if (element) {
    element.scrollIntoView();
  }
}

// Smooth scroll page to first class appearing, in most cases should be called inside $nextTick
export function smoothScrollToClass(cssClass, toolbarOffset) {
  const firstElement = document.getElementsByClassName(cssClass).item(0);
  if (firstElement) {
    if (toolbarOffset) {
      // Toolbar height is 64px
      goTo(firstElement, { offset: 250 });
    } else {
      goTo(firstElement);
    }
  }
}

export function smoothScrollToId(cssId, toolbarOffset) {
  const element = document.getElementById(cssId);
  if (element) {
    if (toolbarOffset) {
      // Toolbar height is 64px
      goTo(element, { offset: 150 });
    } else {
      goTo(element);
    }
  }
}
